// AUTO-GENERATED by scripts/gen-mdi-icons.mjs — do not edit by hand.
// Tree-shaken subset of @mdi/js replacing the full @mdi/font webfont
// (ticket T00HNMV7BCIH). Re-run: node scripts/gen-mdi-icons.mjs
import {
    mdiAccountArrowLeft,
    mdiAccountBox,
    mdiAccountCancelOutline,
    mdiAccountCircle,
    mdiAccountEditOutline,
    mdiAccountGroup,
    mdiAccountSearchOutline,
    mdiAccountSwitch,
    mdiAlert,
    mdiAlertCircle,
    mdiAlertCircleOutline,
    mdiAlertOutline,
    mdiAmpersand,
    mdiAppleKeyboardCommand,
    mdiAppleKeyboardControl,
    mdiAppleKeyboardOption,
    mdiAppleKeyboardShift,
    mdiApplicationOutline,
    mdiArrowDown,
    mdiArrowLeft,
    mdiArrowRight,
    mdiArrowRightCircle,
    mdiArrowUp,
    mdiBackspace,
    mdiBallot,
    mdiBell,
    mdiBookOpenVariant,
    mdiBookmark,
    mdiBriefcaseAccount,
    mdiBullhornOutline,
    mdiCached,
    mdiCalendar,
    mdiCalendarClockOutline,
    mdiCalendarRefreshOutline,
    mdiCardAccountDetailsOutline,
    mdiCartOutline,
    mdiCellphoneLink,
    mdiChartBar,
    mdiChartLine,
    mdiChartTimelineVariant,
    mdiCheck,
    mdiCheckCircle,
    mdiCheckboxBlankOutline,
    mdiCheckboxMarked,
    mdiCheckboxOutline,
    mdiChefHat,
    mdiChevronDown,
    mdiChevronLeft,
    mdiChevronRight,
    mdiChevronUp,
    mdiCircle,
    mdiCircleSmall,
    mdiClipboardArrowUpOutline,
    mdiClock,
    mdiClockAlertOutline,
    mdiClockEnd,
    mdiClockOutline,
    mdiClose,
    mdiCloseCircle,
    mdiCloseCircleOutline,
    mdiCloudUpload,
    mdiCogOutline,
    mdiComment,
    mdiContentCopy,
    mdiDelete,
    mdiDetails,
    mdiDotsVertical,
    mdiDownloadOutline,
    mdiDrag,
    mdiEarth,
    mdiEmailFastOutline,
    mdiEye,
    mdiEyeOff,
    mdiEyedropper,
    mdiFacebook,
    mdiFileCompare,
    mdiFileEyeOutline,
    mdiFileFindOutline,
    mdiFileImage,
    mdiFileMultiple,
    mdiFileMultipleOutline,
    mdiFilePdfBox,
    mdiFileReplaceOutline,
    mdiFilterVariant,
    mdiFitToPage,
    mdiFormTextbox,
    mdiFormatAlignCenter,
    mdiFormatAlignLeft,
    mdiFormatAlignRight,
    mdiFormatBold,
    mdiFormatColorText,
    mdiFormatHeader1,
    mdiFormatHeader2,
    mdiFormatHeader3,
    mdiFormatHeader4,
    mdiFormatHeader5,
    mdiFormatHeader6,
    mdiFormatItalic,
    mdiFormatListBulleted,
    mdiFormatListNumbered,
    mdiFormatListText,
    mdiFormatParagraph,
    mdiFormatText,
    mdiFormatUnderline,
    mdiFullscreen,
    mdiFullscreenExit,
    mdiGithub,
    mdiHead,
    mdiHeadset,
    mdiHeart,
    mdiHeartOutline,
    mdiHelpCircleOutline,
    mdiImage,
    mdiImageAutoAdjust,
    mdiImageMultipleOutline,
    mdiInformation,
    mdiInstagram,
    mdiKeyboardReturn,
    mdiKeyboardSpace,
    mdiLabel,
    mdiLink,
    mdiLinkOff,
    mdiLinkedin,
    mdiLockAlertOutline,
    mdiLockOutline,
    mdiLogout,
    mdiMagnify,
    mdiMagnifyMinus,
    mdiMagnifyPlus,
    mdiMastodon,
    mdiMenu,
    mdiMenuDown,
    mdiMenuOpen,
    mdiMenuRight,
    mdiMessageReplyTextOutline,
    mdiMinus,
    mdiMinusBox,
    mdiMusicBoxOutline,
    mdiNetworkStrength2,
    mdiNetworkStrength4,
    mdiNetworkStrengthOutline,
    mdiNotebook,
    mdiNull,
    mdiOrderBoolAscendingVariant,
    mdiPageFirst,
    mdiPageLast,
    mdiPalette,
    mdiPaperclip,
    mdiPause,
    mdiPencil,
    mdiPencilOutline,
    mdiPinterest,
    mdiPlay,
    mdiPlayOutline,
    mdiPlaylistMusicOutline,
    mdiPlus,
    mdiPrinter,
    mdiProgressCheck,
    mdiRadioboxBlank,
    mdiRadioboxMarked,
    mdiRecycleVariant,
    mdiRocket,
    mdiRocketLaunchOutline,
    mdiScript,
    mdiSelect,
    mdiSelection,
    mdiSnapchat,
    mdiSpotify,
    mdiStar,
    mdiStarCheckOutline,
    mdiStarHalfFull,
    mdiStarOutline,
    mdiStopCircleOutline,
    mdiSubdirectoryArrowRight,
    mdiSvg,
    mdiSwapVertical,
    mdiTable,
    mdiText,
    mdiTrophy,
    mdiTwitch,
    mdiTwitter,
    mdiUnfoldMoreHorizontal,
    mdiUpdate,
    mdiUpload,
    mdiVideoBox,
    mdiViewDashboard,
    mdiViewDashboardOutline,
    mdiViewGridOutline,
    mdiVimeo,
    mdiVolumeHigh,
    mdiVolumeLow,
    mdiVolumeMedium,
    mdiVolumeVariantOff,
    mdiWeb,
    mdiWhatsapp,
    mdiWrenchOutline,
    mdiXml,
    mdiYoutube,
} from '@mdi/js';

/** Maps `mdi-*` icon names (as used across the app + Vuetify internals) to SVG paths. */
export const mdiIconMap: Record<string, string> = {
    'mdi-account-arrow-left': mdiAccountArrowLeft,
    'mdi-account-box': mdiAccountBox,
    'mdi-account-cancel-outline': mdiAccountCancelOutline,
    'mdi-account-circle': mdiAccountCircle,
    'mdi-account-edit-outline': mdiAccountEditOutline,
    'mdi-account-group': mdiAccountGroup,
    'mdi-account-search-outline': mdiAccountSearchOutline,
    'mdi-account-switch': mdiAccountSwitch,
    'mdi-alert': mdiAlert,
    'mdi-alert-circle': mdiAlertCircle,
    'mdi-alert-circle-outline': mdiAlertCircleOutline,
    'mdi-alert-outline': mdiAlertOutline,
    'mdi-ampersand': mdiAmpersand,
    'mdi-apple-keyboard-command': mdiAppleKeyboardCommand,
    'mdi-apple-keyboard-control': mdiAppleKeyboardControl,
    'mdi-apple-keyboard-option': mdiAppleKeyboardOption,
    'mdi-apple-keyboard-shift': mdiAppleKeyboardShift,
    'mdi-application-outline': mdiApplicationOutline,
    'mdi-arrow-down': mdiArrowDown,
    'mdi-arrow-left': mdiArrowLeft,
    'mdi-arrow-right': mdiArrowRight,
    'mdi-arrow-right-circle': mdiArrowRightCircle,
    'mdi-arrow-up': mdiArrowUp,
    'mdi-backspace': mdiBackspace,
    'mdi-ballot': mdiBallot,
    'mdi-bell': mdiBell,
    'mdi-book-open-variant': mdiBookOpenVariant,
    'mdi-bookmark': mdiBookmark,
    'mdi-briefcase-account': mdiBriefcaseAccount,
    'mdi-bullhorn-outline': mdiBullhornOutline,
    'mdi-cached': mdiCached,
    'mdi-calendar': mdiCalendar,
    'mdi-calendar-clock-outline': mdiCalendarClockOutline,
    'mdi-calendar-refresh-outline': mdiCalendarRefreshOutline,
    'mdi-card-account-details-outline': mdiCardAccountDetailsOutline,
    'mdi-cart-outline': mdiCartOutline,
    'mdi-cellphone-link': mdiCellphoneLink,
    'mdi-chart-bar': mdiChartBar,
    'mdi-chart-line': mdiChartLine,
    'mdi-chart-timeline-variant': mdiChartTimelineVariant,
    'mdi-check': mdiCheck,
    'mdi-check-circle': mdiCheckCircle,
    'mdi-checkbox-blank-outline': mdiCheckboxBlankOutline,
    'mdi-checkbox-marked': mdiCheckboxMarked,
    'mdi-checkbox-outline': mdiCheckboxOutline,
    'mdi-chef-hat': mdiChefHat,
    'mdi-chevron-down': mdiChevronDown,
    'mdi-chevron-left': mdiChevronLeft,
    'mdi-chevron-right': mdiChevronRight,
    'mdi-chevron-up': mdiChevronUp,
    'mdi-circle': mdiCircle,
    'mdi-circle-small': mdiCircleSmall,
    'mdi-clipboard-arrow-up-outline': mdiClipboardArrowUpOutline,
    'mdi-clock': mdiClock,
    'mdi-clock-alert-outline': mdiClockAlertOutline,
    'mdi-clock-end': mdiClockEnd,
    'mdi-clock-outline': mdiClockOutline,
    'mdi-close': mdiClose,
    'mdi-close-circle': mdiCloseCircle,
    'mdi-close-circle-outline': mdiCloseCircleOutline,
    'mdi-cloud-upload': mdiCloudUpload,
    'mdi-cog-outline': mdiCogOutline,
    'mdi-comment': mdiComment,
    'mdi-content-copy': mdiContentCopy,
    'mdi-delete': mdiDelete,
    'mdi-details': mdiDetails,
    'mdi-dots-vertical': mdiDotsVertical,
    'mdi-download-outline': mdiDownloadOutline,
    'mdi-drag': mdiDrag,
    'mdi-earth': mdiEarth,
    'mdi-email-fast-outline': mdiEmailFastOutline,
    'mdi-eye': mdiEye,
    'mdi-eye-off': mdiEyeOff,
    'mdi-eyedropper': mdiEyedropper,
    'mdi-facebook': mdiFacebook,
    'mdi-file-compare': mdiFileCompare,
    'mdi-file-eye-outline': mdiFileEyeOutline,
    'mdi-file-find-outline': mdiFileFindOutline,
    'mdi-file-image': mdiFileImage,
    'mdi-file-multiple': mdiFileMultiple,
    'mdi-file-multiple-outline': mdiFileMultipleOutline,
    'mdi-file-pdf-box': mdiFilePdfBox,
    'mdi-file-replace-outline': mdiFileReplaceOutline,
    'mdi-filter-variant': mdiFilterVariant,
    'mdi-fit-to-page': mdiFitToPage,
    'mdi-form-textbox': mdiFormTextbox,
    'mdi-format-align-center': mdiFormatAlignCenter,
    'mdi-format-align-left': mdiFormatAlignLeft,
    'mdi-format-align-right': mdiFormatAlignRight,
    'mdi-format-bold': mdiFormatBold,
    'mdi-format-color-text': mdiFormatColorText,
    'mdi-format-header-1': mdiFormatHeader1,
    'mdi-format-header-2': mdiFormatHeader2,
    'mdi-format-header-3': mdiFormatHeader3,
    'mdi-format-header-4': mdiFormatHeader4,
    'mdi-format-header-5': mdiFormatHeader5,
    'mdi-format-header-6': mdiFormatHeader6,
    'mdi-format-italic': mdiFormatItalic,
    'mdi-format-list-bulleted': mdiFormatListBulleted,
    'mdi-format-list-numbered': mdiFormatListNumbered,
    'mdi-format-list-text': mdiFormatListText,
    'mdi-format-paragraph': mdiFormatParagraph,
    'mdi-format-text': mdiFormatText,
    'mdi-format-underline': mdiFormatUnderline,
    'mdi-fullscreen': mdiFullscreen,
    'mdi-fullscreen-exit': mdiFullscreenExit,
    'mdi-github': mdiGithub,
    'mdi-head': mdiHead,
    'mdi-headset': mdiHeadset,
    'mdi-heart': mdiHeart,
    'mdi-heart-outline': mdiHeartOutline,
    'mdi-help-circle-outline': mdiHelpCircleOutline,
    'mdi-image': mdiImage,
    'mdi-image-auto-adjust': mdiImageAutoAdjust,
    'mdi-image-multiple-outline': mdiImageMultipleOutline,
    'mdi-information': mdiInformation,
    'mdi-instagram': mdiInstagram,
    'mdi-keyboard-return': mdiKeyboardReturn,
    'mdi-keyboard-space': mdiKeyboardSpace,
    'mdi-label': mdiLabel,
    'mdi-link': mdiLink,
    'mdi-link-off': mdiLinkOff,
    'mdi-linkedin': mdiLinkedin,
    'mdi-lock-alert-outline': mdiLockAlertOutline,
    'mdi-lock-outline': mdiLockOutline,
    'mdi-logout': mdiLogout,
    'mdi-magnify': mdiMagnify,
    'mdi-magnify-minus': mdiMagnifyMinus,
    'mdi-magnify-plus': mdiMagnifyPlus,
    'mdi-mastodon': mdiMastodon,
    'mdi-menu': mdiMenu,
    'mdi-menu-down': mdiMenuDown,
    'mdi-menu-open': mdiMenuOpen,
    'mdi-menu-right': mdiMenuRight,
    'mdi-message-reply-text-outline': mdiMessageReplyTextOutline,
    'mdi-minus': mdiMinus,
    'mdi-minus-box': mdiMinusBox,
    'mdi-music-box-outline': mdiMusicBoxOutline,
    'mdi-network-strength-2': mdiNetworkStrength2,
    'mdi-network-strength-4': mdiNetworkStrength4,
    'mdi-network-strength-outline': mdiNetworkStrengthOutline,
    'mdi-notebook': mdiNotebook,
    'mdi-null': mdiNull,
    'mdi-order-bool-ascending-variant': mdiOrderBoolAscendingVariant,
    'mdi-page-first': mdiPageFirst,
    'mdi-page-last': mdiPageLast,
    'mdi-palette': mdiPalette,
    'mdi-paperclip': mdiPaperclip,
    'mdi-pause': mdiPause,
    'mdi-pencil': mdiPencil,
    'mdi-pencil-outline': mdiPencilOutline,
    'mdi-pinterest': mdiPinterest,
    'mdi-play': mdiPlay,
    'mdi-play-outline': mdiPlayOutline,
    'mdi-playlist-music-outline': mdiPlaylistMusicOutline,
    'mdi-plus': mdiPlus,
    'mdi-printer': mdiPrinter,
    'mdi-progress-check': mdiProgressCheck,
    'mdi-radiobox-blank': mdiRadioboxBlank,
    'mdi-radiobox-marked': mdiRadioboxMarked,
    'mdi-recycle-variant': mdiRecycleVariant,
    'mdi-rocket': mdiRocket,
    'mdi-rocket-launch-outline': mdiRocketLaunchOutline,
    'mdi-script': mdiScript,
    'mdi-select': mdiSelect,
    'mdi-selection': mdiSelection,
    'mdi-snapchat': mdiSnapchat,
    'mdi-spotify': mdiSpotify,
    'mdi-star': mdiStar,
    'mdi-star-check-outline': mdiStarCheckOutline,
    'mdi-star-half-full': mdiStarHalfFull,
    'mdi-star-outline': mdiStarOutline,
    'mdi-stop-circle-outline': mdiStopCircleOutline,
    'mdi-subdirectory-arrow-right': mdiSubdirectoryArrowRight,
    'mdi-svg': mdiSvg,
    'mdi-swap-vertical': mdiSwapVertical,
    'mdi-table': mdiTable,
    'mdi-text': mdiText,
    'mdi-trophy': mdiTrophy,
    'mdi-twitch': mdiTwitch,
    'mdi-twitter': mdiTwitter,
    'mdi-unfold-more-horizontal': mdiUnfoldMoreHorizontal,
    'mdi-update': mdiUpdate,
    'mdi-upload': mdiUpload,
    'mdi-video-box': mdiVideoBox,
    'mdi-view-dashboard': mdiViewDashboard,
    'mdi-view-dashboard-outline': mdiViewDashboardOutline,
    'mdi-view-grid-outline': mdiViewGridOutline,
    'mdi-vimeo': mdiVimeo,
    'mdi-volume-high': mdiVolumeHigh,
    'mdi-volume-low': mdiVolumeLow,
    'mdi-volume-medium': mdiVolumeMedium,
    'mdi-volume-variant-off': mdiVolumeVariantOff,
    'mdi-web': mdiWeb,
    'mdi-whatsapp': mdiWhatsapp,
    'mdi-wrench-outline': mdiWrenchOutline,
    'mdi-xml': mdiXml,
    'mdi-youtube': mdiYoutube,
};
